export default __webpack_public_path__ + "static/media/sad.4eaf7363.svg";